/* globals Swiper */
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import { sliderPagination } from '~/js/helpers';

function equalizeTestimonialSlideHeights(swiper) {
	swiper.slides.forEach((slide) => {
		slide.style.height = '';
	});

	const maxHeight = Math.max(0, ...swiper.slides.map((slide) => slide.offsetHeight));

	if (!maxHeight) {
		return;
	}

	swiper.slides.forEach((slide) => {
		slide.style.height = `${maxHeight}px`;
	});
}

const testimonialSliders = [...document.querySelectorAll('.testimonials-slider')];

testimonialSliders.forEach((testimonialSlidersSection) => {
	const testimonialSlider = testimonialSlidersSection.querySelector('.swiper-testimonials-slider');

	if (!testimonialSlider) return;

	const slidesPerView = Number(testimonialSlider.dataset.swiperColumns) || 3;

	const swiper = new Swiper(testimonialSlider, {
		modules: [Navigation, Pagination, A11y],
		a11y: true,
		grabCursor: true,
		loop: false,
		slidesPerView: 1,
		spaceBetween: 32,
		keyboard: {
			enabled: true,
		},
		navigation: {
			nextEl: testimonialSlider.querySelector('.swiper-button-next'),
			prevEl: testimonialSlider.querySelector('.swiper-button-prev'),
		},
		pagination: sliderPagination(testimonialSlider.querySelector('.swiper-pagination')),
		breakpoints: {
			760: { slidesPerView: slidesPerView, spaceBetween: 32 },
			1024: { slidesPerView: slidesPerView },
		},
		on: {
			init(swiperInstance) {
				equalizeTestimonialSlideHeights(swiperInstance);
				requestAnimationFrame(() => equalizeTestimonialSlideHeights(swiperInstance));
			},
			resize(swiperInstance) {
				equalizeTestimonialSlideHeights(swiperInstance);
			},
		},
	});

	window.addEventListener('load', () => equalizeTestimonialSlideHeights(swiper), { once: true });
});
